import { AnalyticsHandler } from "./analytics-handler";
import type { AnalyticsConfig, AnalyticsProviderConfig } from "./types";

let analyticsInstance: AnalyticsHandler | null = null;

const buildHandlerConfig = (config: AnalyticsProviderConfig): AnalyticsConfig => ({
	providers: config.providers,
	posthog: config.posthog,
	axiom: {
		...config.axiom,
		environment: config.environment,
		project: config.project,
	},
});

export function initializeAnalytics(config: AnalyticsProviderConfig): AnalyticsHandler {
	if (!analyticsInstance) {
		const handlerConfig = buildHandlerConfig(config);
		analyticsInstance = new AnalyticsHandler(handlerConfig);
	}
	return analyticsInstance;
}

export function getAnalytics(): AnalyticsHandler {
	if (!analyticsInstance) {
		throw new Error("Analytics not initialized. Call initializeAnalytics first.");
	}
	return analyticsInstance;
}
